import Start from './start.js';

// Load pool model - window.loadPool is called from Vue.JS GUI
// Not using fire/on because Vue.JS may call loadPool() before this script initializes (but always after it's loaded+compiled)
// optionSelections - need to sync up model dimensions, color, install with defaults from UI
// eslint-disable-next-line no-unused-vars
window.loadPool = function (modelName, optionSelections) {
    var app = window.pc.Application.getApplication();

    // A pool model could be selected before the script is ready to accept a pool, in this case, save pool name and load on script init
    if (app && app.root && app.root.findByName('Pool Container')) {
        const entity = app.root.findByName('Pool Container');

        entity.script.dynamicPool.loadPool(modelName, optionSelections);
    } else {
        window.poolOnInit = modelName;
        // "config", here, refers to the user's current product configuration (AKA user selections)
        window.configOnInit = optionSelections;
    }
};

const PlayCanvas = {
    get: name => window.pc.Application.getApplication().root.findByName(name),
    isIndoor: true,

    // Start loading PlayCanvas canvas; executed only once on load
    startLoading() {
        const load = function() {
            if (window.pc && window.loadModules) {
                Start.initPlayCanvas();
            } else {
                setTimeout(load, 250);
            }
        };

        load();
    },
    // change selected model
    updateModel(model, poolCategory, userSelections, handle=null) {
        // Tell PC to clear accessories
        if (window?.pc?.app) window.pc.app.fire('acc:clear');

        if (poolCategory === 'custom') {
            if (model === 'sp105') {
                window.loadPool(model, {
                    type: poolCategory,
                    install: userSelections.install.value,
                });
            } else {
                window.loadPool(model, {
                    type: poolCategory,
                    liner: userSelections.liner.value,
                    system: userSelections.system.value,
                    coping: userSelections.coping.value,
                    install: userSelections.install.value,
                    skirting: userSelections.skirting.value
                });
            }
        } else if (poolCategory === 'spa') {
            window.loadPool(model, {
                type: poolCategory,
                shell: userSelections.shell.value,
                skirting: userSelections.skirting.value,
                install: userSelections.install.value,
            });
        } else {
            console.error('Unable to update model - unknown category', poolCategory);
        }
        // Update URL
        if (handle) {
            let url = new URL(window.location.href);
            url.searchParams.set('model', handle);
            window.history.replaceState(window.history.state, null, url.href)
        }
    },
    resizePool(len, width, depth) {
        window.pc.app.fire('dynamic:resizePool', len, width, depth);
    },
    setPoolTexture(optionKey, value) {
        if (optionKey === 'liner') {
            // projected
            window.pc.app.fire('dynamic:setMeshTexture', optionKey, value);
        } else  {
            // not projected
            window.pc.app.fire('dynamic:setModelTexture', optionKey, value);
            // for system, accessories may also need texture changed
            if (optionKey === 'system') {
                window.pc.app.fire('acc:setOptionChoice', 'system', value);
            }
        }
    },
    changingLocation: false,
    setLocation(isIndoor) {
        // Prevent user from spamming location buttons and breaking asset load behavior
        if (!this.changingLocation) {
            this.changingLocation = true;
            window.pc.app.once('vue:doneSwitch', () => {
                this.changingLocation = false;
            });
            window.pc.app.fire('env:switch', isIndoor);
        }
    },
    setInstall(install) {
        window.pc.app.fire('dynamic:setInstall', install);
    },
    enableAccessory(accKey, optionSelections) {
        window.pc.app.fire('acc:enable', accKey, optionSelections);
    },
    disableAccessory(accKey) {
        window.pc.app.fire('acc:disable', accKey);
    },
    setAccessoryColor(accKey, hexColor) {
        window.pc.app.fire('acc:update-color', accKey, hexColor);
    },
    toggleLEDLighting() {
        window.pc.app.fire('acc:toggle-LED');
    },
};

export default PlayCanvas;
